export default __webpack_public_path__ + "static/media/App-banner-mob.011e6251.jpg";